  <app-error-box [errors]="this.apiSvc.lastErrors"></app-error-box>

  <ng-container *ngFor="let baustein of bausteinRowList">
    <div class="baustein-container" id="tarifbox">
      <ng-container *ngFor="let pm of baustein.bausteinList; first as isFirst;">
        <app-baustein
          (tariffActiveStatusChanged)="this.onTariffActiveStatusChanged($event)"
          (tariffStatusChanged)="this.onTariffStatusChanged()"
          [baustein]="pm"
          [isFirst]="isFirst"
          [isDouble]="baustein.bausteinList > 1"
          [context]="this.structuredContentService.getConfig().contextId"
          [isAlternativeColor]="pm.alternativeColor"
        >
        </app-baustein>
      </ng-container>
    </div>
  </ng-container>
